import { getNavElements } from "consts";
import { usePolicyDetail, useSelectedPolicy } from "data/ss-data-hooks";
import { matchesCarrierGroupOrFlood } from "utils";

const HIDE_PROPERTY_CARRIERS = ["vave", "markel"];

export const useNavItems = () => {
  const { data } = useSelectedPolicy();
  const { data: detailData } = usePolicyDetail();
  const { carrierGroup, policyType } = detailData?.userPolicyProperties ?? {};
  const hidePropertyTab =
    data?.isCommercial ||
    matchesCarrierGroupOrFlood(
      carrierGroup,
      policyType,
      HIDE_PROPERTY_CARRIERS,
    );

  return getNavElements(hidePropertyTab);
};
